import {
  ADD_TO_CART,
  CART_COUNT,
  UPDATE_QUOTE_UNIQUE_ID,
  UPDATE_CART_UNIQUE_ID,
} from "../actions/addToCart";

const initialState = {
  cart: [],
  assayCartHtml: [],
  messages: [],
  cartAssayUniqueId: [],
  quoteAssayUniqueId: [],
};

const addToCart = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      return {
        ...state,
        cart: [...state.cart, action.payload.orderInfo],
      };

    case UPDATE_CART_UNIQUE_ID:
      return {
        ...state,
        cartAssayUniqueId: [...state.cartAssayUniqueId, action.payload],
      };

    case UPDATE_QUOTE_UNIQUE_ID:
      return {
        ...state,
        quoteAssayUniqueId: [...state.quoteAssayUniqueId, action.payload],
      };

    case CART_COUNT:
      return Object.assign({}, state, {
        assayCartHtml: action.payload,
      });

    default:
      return state;
  }
};

export default addToCart;
